{
  "titles": {
    "confirm_password_reset": "Reset your password"
  },
  "descriptions": {
    "confirm_password_reset": "We’ve emailed you a link to reset your password"
  },
  "buttons": {
    "confirm_password_reset": "Return to login"
  }
}
